import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import { store } from "@/store/store";

const api: AxiosInstance = axios.create({
  baseURL: "/api",
  headers: {
    "Content-Type": "application/json",
  },
  xsrfCookieName: "csrftoken",
  xsrfHeaderName: "X-CSRFTOKEN",
});

api.interceptors.request.use((config: AxiosRequestConfig) => {
  if (config.headers != undefined) {
    config.headers.Authorization = store.getters.idToken;
  }
  return config;
});

const scan: AxiosInstance = axios.create({
  baseURL: "/scan",
});

const http = { api: api, scan: scan };

export default http;
